import { Component } from '@angular/core';

@Component({
  selector: 'app-leave-calendar-legend',
  imports: [],
  template: `
    <div
      class="tw-flex tw-gap-4 tw-flex-wrap tw-font-bold tw-text-[var(--sed-black-80-color)]"
    >
      <div class="tw-flex tw-items-center">
        <div
          class="tw-rounded-full tw-size-4 tw-bg-[var(--sed-status-green-color)] tw-mr-2"
        ></div>
        <div>Approved</div>
      </div>

      <div class="tw-flex tw-items-center">
        <div
          class="tw-rounded-full tw-size-4 tw-bg-[var(--sed-status-yellow-color)] tw-mr-2"
        ></div>
        <div>Pending</div>
      </div>

      <div class="tw-flex tw-items-center">
        <div
          class="tw-rounded-full tw-size-4 tw-bg-[var(--sed-status-red-color)] tw-mr-2"
        ></div>
        <div>Denied</div>
      </div>

      <div class="tw-flex tw-items-center">
        <div
          class="tw-rounded-full tw-size-4 tw-bg-[var(--sed-data-teal-color)] tw-mr-2"
        ></div>
        <div>Event</div>
      </div>

      <div class="tw-flex tw-items-center">
        <div
          class="tw-rounded-full tw-size-4 tw-bg-[var(--sed-black-80-color)] tw-mr-2"
        ></div>
        <div>Multiple</div>
      </div>
    </div>
  `,
  styles: ``,
})
export class LeaveCalendarLegendComponent {}
